import * as React from 'react';
const SvgIcon = props => {
  return <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="#fff" viewBox="0 -960 960 960">
      <path fill={props.fill || '#1D252D'} d="M268.46-140v-128.46H140v-60h188.46V-140zm363.46 0v-188.46h188.46v60H691.92V-140zM140-631.54v-60h128.46V-820h60v188.46zm491.92 0V-820h60v128.46h128.46v60z"></path>
    </svg>;
};
export default React.memo(SvgIcon);